import ScrollMagic from 'scrollmagic';
import 'vendor/scrollmagic-add-indicators.js';
import segment from 'common/segment';

const SHOW_ANIMATION = 'active-animation';
const RESET_ANIMATION = 'hide-animation';

const animationNodes = document.querySelectorAll(
  '[data-js="starter-kit-page-section"]'
);
const controller = new ScrollMagic.Controller();

let farthestSeenAnimation = null;
let lastSeenAnimation = null;

export const initAnimations = () => {
  if (animationNodes.length) {
    animationNodes.forEach((node, index) => {
      // Scene to trigger the animation at 10% of the screen
      new ScrollMagic.Scene({
        triggerElement: node,
        triggerHook: 0.7,
      })
        .on('enter', () => {
          node.classList.remove(RESET_ANIMATION);
          node.classList.add(SHOW_ANIMATION);
          lastSeenAnimation = index;
          if (farthestSeenAnimation === null || index > farthestSeenAnimation) {
            farthestSeenAnimation = index;
          }
        })
        .addTo(controller);
      // Scene to reset the block so that it'll animate back in on scroll down
      new ScrollMagic.Scene({
        triggerElement: node,
        triggerHook: 1,
      })
        .on('leave', event => {
          if (event.state === 'BEFORE') {
            node.classList.add(RESET_ANIMATION);
            node.classList.remove(SHOW_ANIMATION);
          }
        })
        .addTo(controller);
    });

    window.addEventListener('unload', () => {
      segment.track('PDP_Animations', {
        lastAnimation: lastSeenAnimation,
        farthestSeenAnimation,
        totalAnimationsOnPage: animationNodes.length,
        animationsPage: 'Starter Kit',
      });
    });
  }
};
